import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import { WrappedInput } from './inline-input';
import { sendVerificationCode } from '../actions/user';
import { connect } from 'react-redux';
import { TextButton } from './button';

export const FIELD_ICON_LEFT = 35;

const IconField = styled.div`
  position: relative;
  margin: 0 75px;
`;

IconField.Label = styled.label`
  display: block;
  font-size: 32px;
  color: white;
  font-weight: 500;
  width: 100%;
  line-height: 1;
  padding: 24px 0 24px 31px;
  
  .light-bg & {
    color: rgb(102, 102, 102);
  }
`;

IconField.Input = styled(WrappedInput)`
  background: none;
  width: 100%;
  font-size: 30px;
  color: white;
  border: none;
  border-bottom: 1px solid white;
  padding: 0 0 32px 105px;
  
  .light-bg & {
    color: rgb(51, 51, 51);
    border-bottom: 1px solid #dbdbdb;
  }
  
  &:focus, &:hover,
  &:active {
    outline: none !important;
  }
`;

IconField.Icon = styled.img`
  position: absolute;
  top: ${24 + 32 + 24}px;
  left: ${FIELD_ICON_LEFT}px;
  color: white;
`;

export const LightBackgroundField = ({ className, children, ...props }) => (
  <IconField className={`${className} light-bg`} {...props}>
    {children}
  </IconField>
);

LightBackgroundField.defaultProps = {
  className: ''
};

LightBackgroundField.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

LightBackgroundField.Label = IconField.Label;
LightBackgroundField.Input = IconField.Input;
LightBackgroundField.Icon = IconField.Icon;

export default IconField;

const _GetVerificationButtonField = (props) => {
  const {
    meta: { error, dispatch },
    input: { value },
    nextVerify,
    style, className, scope
  } = props;
  if (!props.meta || !props.input) return null;
  return (
    <TextButton
      style={style}
      className={className}
      disabled={nextVerify > 0 || error}
      type='button'
      onClick={() => dispatch(sendVerificationCode(value, scope))}>
      { nextVerify > 0 ? `${nextVerify}s重新获取` : '获取验证码' }
    </TextButton>
  );
};

_GetVerificationButtonField.defaultProps = {
  style: {},
  className: null,
  meta: null,
  input: null,
};

_GetVerificationButtonField.propTypes = {
  meta: PropTypes.shape({
    error: PropTypes.string,
    dispatch: PropTypes.func,
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
  }),
  nextVerify: PropTypes.number.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  scope: PropTypes.oneOf(['register', 'reset_password']).isRequired,
};

export const GetVerificationButtonField = connect(state => ({
  nextVerify: state.user.nextVerify,
}))(_GetVerificationButtonField);



// WEBPACK FOOTER //
// ./src/components/input-field.jsx